interface AdBannerProps {
  position?: 'horizontal' | 'vertical' | 'square';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  adId?: string; // Novo: identificador único para cada anúncio
}

function getDimensions(position?: string, size?: string) {
  if (position === 'horizontal') {
    if (size === 'small') return 'w-full h-24';
    if (size === 'large') return 'w-full h-48';
    return 'w-full h-32'; // medium
  }
  
  if (position === 'vertical') {
    if (size === 'small') return 'w-48 h-96';
    if (size === 'large') return 'w-80 h-[600px]';
    return 'w-64 h-[500px]'; // medium
  }
  
  // square
  if (size === 'small') return 'w-48 h-48';
  if (size === 'large') return 'w-80 h-80';
  return 'w-64 h-64'; // medium
}

// Configuração de anúncios - pode ser facilmente modificada para cada espaço
const adConfigs: Record<string, { link: string; image: string; alt: string }> = {
  'sidebar-1': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  },
  'sidebar-2': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  },
  'sidebar-3': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  },
  'before-footer': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  },
  'before-feedback': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  },
  'default': {
    link: 'https://www.caixa.gov.br',
    image: 'https://static.readdy.ai/image/438d7327661f8337353330b1967a2233/c559ee5e5ad76190009f44c82d3697f2.jpeg',
    alt: 'Caixa Econômica Federal'
  }
};

export default function AdBanner({ position, size, adId = 'default' }: AdBannerProps) {
  const dimensions = getDimensions(position, size);
  const adConfig = adConfigs[adId] || adConfigs['default'];

  return (
    <div 
      className={`${dimensions} rounded-xl shadow-lg overflow-hidden`}
    >
      <a 
        href={adConfig.link}
        target="_blank" 
        rel="noopener noreferrer"
        className="block w-full h-full hover:opacity-95 transition-opacity duration-300 cursor-pointer"
      >
        <img 
          src={adConfig.image}
          alt={adConfig.alt}
          className="w-full h-full object-cover"
        />
      </a>
    </div>
  );
}
